import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AddCreditCardRequest, Card, CardType } from './card.model'
import { map } from 'rxjs/operators'

@Injectable()
export class CardsService {
  constructor(private http: HttpClient) {}

  creditCards(): Observable<Card[]> {
    return this.http.get<Card[]>(`@api/subscribe/cards/`)
  }

  addCCard(payload: AddCreditCardRequest): Observable<Card> {
    return this.http.post<Card>(`@api/subscribe/add/cc`, payload)
  }

  deleteCCard(id: string) {
    return this.http.delete(`@api/subscribe/delete/cc/${id}`)
  }

  getCards(): Observable<Card[]> {
    return this.http.get<{ cards: Card[] }>(`@api/cards`).pipe(map((response) => response.cards))
  }

  addCard(payload: { type: CardType; payment_method: string }) {
    return this.http.post<{ cards: Card[] }>(`@api/cards`, payload).pipe(map((response) => response.cards))
  }

  deleteCard(id: string) {
    return this.http.delete<{ cards: Card[] }>(`@api/cards/${id}`).pipe(map((response) => response.cards))
  }
}
